import { render, staticRenderFns } from "./hi-checkbox-single.vue?vue&type=template&id=2a7e96d8"
import script from "./hi-checkbox-single.vue?vue&type=script&lang=ts"
export * from "./hi-checkbox-single.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports